<template>
  <div id="about_nav">
    <div class="nav-top">
      <div class="top-box">
        <h3>信息披露</h3>
        <p>Information disclosure</p>
      </div>
    </div>
    <div class="nav-box">
      <div class="nav-bottom">
        <div class="seat-box">
          <h3>
            您的位置：首页 > 信息披露 > 
            <span>捐赠数据</span>
          </h3>
          <div :class="{'border-box':classShow}"></div>
        </div>
        <ul>
          <li
            v-for="(item,index) in navList"
            :key="index"
            @click="getStyle(item.id)"
            :class="{active:liStatus==item.id}"
          >{{item.title}}</li>
        </ul>
      </div>
    </div>
    <div class="nav-content">
      <infoList></infoList>
    </div>
  </div>
</template>
<script>
import infoList from "./info_list";

export default {
  components: {
    infoList
  },
  data() {
    return {
      classShow: true,
      classHide: false,
      navShow: 1,
      navList: [
                                                               
        {
          id: 1,
          title: "年检报告"
        },
        {
          id: 2,
          title: "管理制度"
        },
        {
          id: 3,
          title: "审计报告"
        },
        {
          id: 4,
          title: "项目总结"
        },
        {
          id: 5,
          title: "捐赠数据"
        },
        {
          id: 6,
          title: "相关证书"
        },
        {
          id: 7,
          title: "支出数据"
        }
      ],
      liStatus: 5
    };
  },
  methods: {
    getStyle(id) {
      this.liStatus = id;
      this.navShow = id;
    }
  }
};
</script>
<style lang="scss" scoped>
#about_nav {
  width: 100%;
}
.nav-top {
  width: 100%;
  height: 300px;
  background: url(../../assets/images/nav_bg.png) no-repeat;
  background-size: 100% 100%;
  .top-box {
    width: 1300px;
    margin: 0 auto;
    padding-top: 118px;
    > h3 {
      font-size: 36px;
      color: #333333;
      font-weight: normal;
    }
    > p {
      font-size: 26px;
      font-weight: normal;
      color: #999999;
    }
  }
}
.nav-box {
  width: 1300px;
  margin: 0 auto;
  // margin-bottom: 86px;
  .nav-bottom {
    width: 100%;
    .seat-box {
      > h3 {
        font-size: 14px;
        color: #999;
        text-align: right;
        font-weight: normal;
        padding: 28px 0 17px;
        > span {
          color: #333333;
        }
      }
      .border-box {
        width: 1300px;
        height: 1px;
        border: 1px solid #c30d23;
        border-bottom: 3px solid #c30d23;
      }
    }
    > ul {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      > li {
        list-style: none;
        padding: 15px 25px;
        font-size: 18px;
        color: #000000;
        cursor: pointer;
        &.active {
          // background-color: #fff;
          background-color: #c30d23;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Info/info_nav.vue